import type { BaseKeyFunction } from "../../../../lib";

export const keyCommunitiesAdminCommunities: BaseKeyFunction = () => [
  "communities-admin-communities",
];
